import PolicyLayout from './PolicyLayout';
import { SITE_NAME } from '../constants/site';
import { CONTACT } from '../constants/contact';

export default function RefundPolicy() {
  return (
    <PolicyLayout title="Refund and Returns Policy">
      <h2>Software & support</h2>
      <p>
        {SITE_NAME} refund eligibility depends on the product license rules and whether activation or
        download has already occurred. Contact us before opening a dispute so we can review your case.
      </p>
      <h2>How to request a return</h2>
      <p>
        Email {CONTACT.email} or use live chat with your order details and reason for return. We
        typically respond within one business day.
      </p>
      <h2>Mailing address</h2>
      <p>
        {CONTACT.company}<br />
        {CONTACT.addressLine1}<br />
        {CONTACT.addressLine2}
      </p>
    </PolicyLayout>
  );
}
